import { render, staticRenderFns } from "./OutboundStatistics.vue?vue&type=template&id=62f19fea&scoped=true"
import script from "./OutboundStatistics.vue?vue&type=script&lang=js"
export * from "./OutboundStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f19fea",
  null
  
)

export default component.exports